import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import lottie from 'lottie-web';
import { useRef, useEffect } from 'react';
import '../constants/bottomNavigationBar.js';
import '../constants/footer.js';
import '../constants/footerQuickMenuItem.js';
import { COMMON_PREFIX } from '../constants/global.js';

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function useLottie(name, animationData) {
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var $element = useRef(null);
  useEffect(function () {
    var _context;
    var id = _concatInstanceProperty(_context = "".concat(COMMON_PREFIX, "-")).call(_context, name, "-");
    if ($element.current) {
      lottie.setIDPrefix(id);
      lottie.loadAnimation(_objectSpread(_objectSpread({}, option), {}, {
        animationData: animationData,
        renderer: 'svg',
        name: id,
        container: $element.current
      }));
    }
    return function () {
      lottie.destroy(id);
    };
  }, [animationData, name, option]);
  return $element;
}

export { useLottie as default };
